import { ARCHIVED_COLUMN, LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Zone Name',
    field: 'zone',
    width: LIST_WIDTH.xl,
  },
  {
    headerName: 'Risk Level',
    field: 'riskLevel',
    width: LIST_WIDTH.default,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Likelihood',
    field: 'likelihood',
    width: LIST_WIDTH.default,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Consequence',
    field: 'consequence',
    width: LIST_WIDTH.default,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Hazard',
    field: 'hazard',
    width: LIST_WIDTH.xl,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
];
